import $api from "../http";
import { AxiosResponse } from "axios";
import { IArticle, IArticleRes } from "../models/IArticle";
import { getNewsUrl } from "../utils";

export default class ArticlesService {
  static async fetchList(
    status: string[],
    page: number
  ): Promise<AxiosResponse<IArticleRes>> {
    console.log(status, page)
    const url =
      getNewsUrl(`/articles?page=${page}&`, status) || "/articles";
    return await $api.get<IArticleRes>(url);
  }

  static async fetchCreateOne(data: IArticle): Promise<AxiosResponse<boolean>> {
    return await $api.put<boolean>("/articles", data, {
      onUploadProgress: (progressEvent) => {
        console.log(`${(progressEvent.loaded / progressEvent.total) * 100}%`);
      },
    });
  }

  static async fetchUpdateOne(data: IArticle): Promise<AxiosResponse<boolean>> {
    return await $api.post<boolean>("/articles", data, {
      onUploadProgress: (progressEvent) => {
        console.log(`${(progressEvent.loaded / progressEvent.total) * 100}%`);
      },
    });
  }

  static async fetchDeleteOne(
    id: string | undefined
  ): Promise<AxiosResponse<boolean>> {
    return await $api.delete<boolean>(`/articles/${id}`);
  }

  static async uploadImage(
    file: File
  ): Promise<AxiosResponse<{ url: string }>> {
    const formData = new FormData();
    formData.append("image", file);
    return await $api.post<{ url: string }>(
      "/articles/uploadEditorImage",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
}
